import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {action, observable, runInAction} from 'mobx';
import range from 'lodash/range';
import debounce from 'lodash/debounce';
import isNumber from 'lodash/isNumber';
import {withHover} from '../../../compose/withHover';
import StudioPlayerTrackArc from './StudioPlayerTrackArc';
import tickMP3 from '../../../assets/audio/tick.mp3';
import StudioPlayerTrackHandle from './StudioPlayerTrackHandle';
// import StudioPlayerTrackCornerLeft from "./StudioPlayerTrackCornerLeft";
// import StudioPlayerTrackCornerRight from "./StudioPlayerTrackCornerRight";
import {convertToAngles, getBeatFromAngle, tau} from './studioUtility';
import {isIpad} from "../../../utils/screenUtility";
import StudioPlayerTrackWave from "./StudioPlayerTrackWave";
import CSSTransition from "../../../components/CSSTransition";


@inject('looperStore', 'studioStore')
@withHover
@observer
class StudioPlayerTrackLegoArc extends Component {
    @observable startAngle = 0;
    @observable endAngle = tau;
    @observable rotateAngle = 0;

    @observable preventClick = false;
    @observable duringDrag = false;
    @observable duringSelectDrag = false;
    @observable selected = false;
    @observable startRotate = 0;
    @observable angelLength = 0;
    @observable snapToGrid = false;

    @observable selectedBeat;
    @observable isHovering = false;

    // @observable animationDone = false;

    componentDidMount() {
        this.isLeftTrim = null;
        this.setAngles(this.props.split, this.props.beatCount, this.props.minStartBeat, this.props.maxEndBeat);
        //
        // const {looperStore} = this.props;
        // reaction(() => {
        //     return looperStore.isLooperLoaded;
        // }, () => {
        //     if (looperStore.isLooperLoaded) {
        //         const delay = (MAX_LOOPER_TRACKS - this.props.tier) * 130;
        //         const isLastTrack = this.props.trackLength === MAX_LOOPER_TRACKS - this.props.tier;
        //         setTimeout(() => {
        //             this.onHover();
        //             setTimeout(() => {
        //                 this.onHoverLeave();
        //                 if (isLastTrack) {
        //                     runInAction(() => {
        //                         this.props.finishStemsAnimation(true);
        //                     });
        //                 }
        //             }, delay);
        //         }, delay);
        //     }
        // });
    }

    setAngles = (split, beatCount, minStartBeat, maxEndBeat) => {
        runInAction(() => {
            this.rotateAngle = convertToAngles(split.offset || 0, beatCount);
            this.origStartAngle = convertToAngles(split.start, beatCount);
            this.startAngleNoTrim = convertToAngles(split.start, beatCount);
            this.startAngle = convertToAngles(split.leftTrim || split.start, beatCount);
            this.origEndAngle = convertToAngles(split.end, beatCount);
            this.endAngle = convertToAngles(split.rightTrim || split.end, beatCount);
            this.angelLength = this.endAngle - this.startAngle;
            this.minAngle = Math.max(0, convertToAngles(minStartBeat, beatCount));
            this.maxAngle = Math.min(tau, convertToAngles(maxEndBeat, beatCount));
            this.maxAngleLength = convertToAngles(split.end, beatCount) - convertToAngles(split.start, beatCount);
            //     this.props.calculateAngles(this.props.tier, this.props.index, this.startAngle + this.rotateAngle, this.endAngle + this.rotateAngle);
        });
    };

    componentWillUpdate(nextProps) {
        if (!this.duringDrag && (nextProps.split !== this.props.split || nextProps.beatCount !== this.props.beatCount
                || nextProps.minStartBeat !== this.props.minStartBeat || nextProps.maxEndBeat !== this.props.maxEndBeat)) {
            this.setAngles(nextProps.split, nextProps.beatCount, nextProps.minStartBeat, nextProps.maxEndBeat);
        }
        if (nextProps.split.selected !== this.selected) {
            runInAction(() => {
                this.selected = nextProps.split.selected;
            });
        }
    }

    /**
     * returns the gridAngle if angle is close to a gridline (max distance is 60% from halfway point)
     *
     * @param angle
     * @returns {*}
     */
    findClosestGrid(angle) {
        const gridAngle = tau / this.props.beatCount;

        const r = Math.round(angle / gridAngle);
        if (Math.abs((angle / gridAngle) - r) <= gridAngle * 0.6) {
            return r * gridAngle;
        }
        return null;
    }

    /**
     * always returns the closest grid line closest to the angle, regardless of distance
     *
     * @param angle
     * @returns {number}
     */

    forceFindClosestGrid(angle) {
        const gridAngle = tau / this.props.beatCount;

        const r = Math.round(angle / gridAngle);
        return r * gridAngle;
    }

    @action onTrimLeft = (angle, beat) => {
        const {beatCount, index, tier, onSnap, onTrim, onSnapEnd, split} = this.props;
        this.duringDrag = true;
        this.isLeftTrim = true;
        let newAngle = angle;
        const origStartAngle = this.origStartAngle + this.rotateAngle;
        const startAngle = this.startAngle + this.rotateAngle;
        const endAngle = this.endAngle + this.rotateAngle;
        const gridAngle = tau / beatCount;

        if (newAngle < this.minAngle) {
            newAngle = this.minAngle;
        }
        if (newAngle < origStartAngle) {
            newAngle = origStartAngle;
        } else if (endAngle - newAngle > this.maxAngleLength) {
            newAngle = startAngle;
        } else if (newAngle > endAngle || endAngle - newAngle < gridAngle) {
            // make sure startAngle is more than a gridAngle away from end angle
            newAngle = endAngle - gridAngle;
        }

        split.selectedBeats = split.selectedBeats.filter(selected => selected !== beat);

        const closestGridLine = this.findClosestGrid(newAngle);
        if (closestGridLine) {
            if (newAngle < startAngle) {
                this.playTick();
            }
            this.startAngle = closestGridLine - this.rotateAngle;
            if (onSnap) {
                onSnap(tier, index, this.startAngle + this.rotateAngle, this.endAngle + this.rotateAngle);
            }
        } else {
            if (onSnapEnd) {
                onSnapEnd();
            }

            this.startAngle = newAngle - this.rotateAngle;
            if (onTrim) {
                onTrim(tier, index, this.startAngle + this.rotateAngle, this.endAngle + this.rotateAngle);
            }
        }
        this.angelLength = this.endAngle - this.startAngle;
    };

    @action onTrimRight = (angle, beat) => {
        const {beatCount, index, tier, onSnap, onTrim, split} = this.props;
        this.duringDrag = true;
        this.isLeftTrim = false;
        let newAngle = angle;
        const startAngle = this.startAngle + this.rotateAngle;
        const origEndAngle = this.origEndAngle + this.rotateAngle;
        const endAngle = this.endAngle + this.rotateAngle;
        const gridAngle = tau / beatCount;

        if (newAngle > this.maxAngle) {
            newAngle = this.maxAngle;
        }
        if (newAngle > origEndAngle) {
            newAngle = origEndAngle;
        } else if (newAngle - startAngle > this.maxAngleLength) {
            newAngle = endAngle;
        } else if (newAngle < startAngle || newAngle - startAngle < gridAngle) {
            newAngle = startAngle + gridAngle;
        }

        split.selectedBeats = split.selectedBeats && split.selectedBeats.filter(selected => selected !== beat);

        const closestGridLine = this.findClosestGrid(newAngle);
        if (closestGridLine) {
            if (newAngle > endAngle) {
                this.playTick();
            }
            this.endAngle = closestGridLine - this.rotateAngle;
            if (onSnap) {
                onSnap(tier, index, this.startAngle + this.rotateAngle, this.endAngle + this.rotateAngle);
            }
        } else {
            this.endAngle = newAngle - this.rotateAngle;
            if (onTrim) {
                onTrim(tier, index, this.startAngle + this.rotateAngle, this.endAngle + this.rotateAngle);
            }
        }
        this.angelLength = this.endAngle - this.startAngle;
    };

    @action onTrimEnd = () => {
        const {beatCount, index, tier, onSnap, onTrimEnd, onSnapEnd, split} = this.props;

        if (this.duringDrag) {
            this.duringDrag = false;
            this.playTick();


            let targetAngle = (this.isLeftTrim ? this.startAngle : this.endAngle) + this.rotateAngle;
            let closestGridLine = this.forceFindClosestGrid(targetAngle);

            if (!this.isLeftTrim && Math.abs((this.endAngle + this.rotateAngle) - tau) <= 0.0001) {
                closestGridLine = this.endAngle - this.angelLength + this.rotateAngle;
            }
            if (closestGridLine) {
                this.startAngle = Math.max(this.isLeftTrim ? (closestGridLine - this.rotateAngle) : this.startAngle, this.minAngle);
                this.endAngle = Math.min(this.isLeftTrim ? this.endAngle : (closestGridLine - this.rotateAngle), this.startAngle + this.maxAngleLength);
            }
            this.angelLength = this.endAngle - this.startAngle;

            if (this.isLeftTrim) {
                split.leftTrim = getBeatFromAngle(this.startAngle, beatCount, true, true);
                this.startAngleNoTrim = this.startAngle;
            } else {
                split.rightTrim = getBeatFromAngle(this.endAngle, beatCount, true, true);
            }

            if (onSnap) {
                onSnap(tier, index, this.startAngle + this.rotateAngle, this.endAngle + this.rotateAngle);
            }
        }
        if (onSnapEnd) {
            onSnapEnd();
        }
        if (onTrimEnd) {
            onTrimEnd(this.isLeftTrim, tier, index);
        }
        this.isLeftTrim = null;
    };

    @action
    onDragStemStart = (angle) => {
        if (this.props.mobileView) return;
        this.prevRotateAngle = this.rotateAngle;
        this.startRotate = angle - this.rotateAngle;
        if (this.props.onDragStart) {
            this.props.onDragStart();
        }
    };

    @action
    onDragStem = (angle) => {
        if (this.props.mobileView) return;
        const {index, tier, onSnap, onDragEvent, onSnapEnd} = this.props;
        this.duringDrag = true;

        this.prevRotateAngle = angle;
        const rotateAngle = angle - this.startRotate;
        const startAngle = rotateAngle + this.startAngle;
        const endAngle = startAngle + this.angelLength;
        // console.log('startAngle: ' , startAngle, ', endAngle: ', endAngle, ',maxAngle: ' , this.maxAngle, ', minAngle: ' + this.minAngle);
        if (endAngle > this.maxAngle) {
            this.rotateAngle = (-this.startAngle + this.maxAngle) - this.angelLength;
            return;
        }
        if (startAngle < this.minAngle) {
            this.rotateAngle = -this.startAngle + this.minAngle;
            return;
        }

        const closestGridLine = this.findClosestGrid(startAngle);
        if (closestGridLine !== null) {
            this.rotateAngle = closestGridLine - this.startAngle;
            if (rotateAngle < this.rotateAngle) {
                this.playTick();
            }
            this.snapToGrid = true;
            const startA = closestGridLine;
            const endA = closestGridLine + this.angelLength;
            if (onSnap) {
                onSnap(tier, index, startA, endA);
            }
        } else {
            if (onSnapEnd) {
                onSnapEnd();
            }
            this.snapToGrid = false;
            this.rotateAngle = rotateAngle;

            if (onDragEvent) {
                onDragEvent(tier, index, startAngle, endAngle);
            }
        }
    };

    playTick = debounce(async () => {
        const tick = new Audio(tickMP3);
        tick.playbackRate = 4;
        try {
            await tick.play();
        } catch (err) {
            console.error(err);
        }
    }, 50);

    fixSelections = () => {
        if (this.props.split.selectedBeats) {
            this.props.split.selectedBeats = this.props.split.selectedBeats.map((beat) => {
                return beat + getBeatFromAngle(this.rotateAngle - this.prevRotateAngle, this.props.beatCount);
            });
        }
        if (this.props.split.mutedBeats) {
            this.props.split.mutedBeats = this.props.split.mutedBeats.map((beat) => {
                return beat + getBeatFromAngle(this.rotateAngle - this.prevRotateAngle, this.props.beatCount);
            });
        }
    };

    @action
    onDragStemEnd = () => {
        if (this.props.mobileView) return;
        const {beatCount, index, tier, onSnap, onDragEnd, onSnapEnd, split} = this.props;
        if (!this.duringDrag) {
            return;
        }
        if (this.duringDrag && this.prevRotateAngle !== this.rotateAngle) {
            this.fixSelections();
        }
        this.duringDrag = false;
        this.snapToGrid = false;

        let startAngle;
        let endAngle;
        let closestGridLine = this.forceFindClosestGrid(this.startAngle + this.rotateAngle);
        // console.log('tau diff: ' + Math.abs(this.endAngle - tau));
        if (Math.abs((this.endAngle + this.rotateAngle) - tau) <= 0.0001) {
            closestGridLine = this.endAngle - this.angelLength + this.rotateAngle;
        }
        if (closestGridLine !== null) {
            this.playTick();
            let rotateAngle = closestGridLine - this.startAngle;
            startAngle = closestGridLine;
            endAngle = closestGridLine + this.angelLength;
            if (endAngle > this.maxAngle) {
                rotateAngle = (-this.startAngle + this.maxAngle) - this.angelLength;
            }
            if (startAngle < this.minAngle) {
                rotateAngle = -this.startAngle + this.minAngle;
            }
            this.rotateAngle = rotateAngle;
            if (onSnap) {
                onSnap(tier, index, startAngle, endAngle);
            }
            // this.startAngle = startAngle;
            // this.endAngle = endAngle;
        } else {
            startAngle = this.rotateAngle + this.startAngle;
            endAngle = startAngle + this.angelLength;
        }
        if (onDragEnd) {
            const oldOffset = split.offset;
            split.offset = getBeatFromAngle(this.rotateAngle, beatCount, true, true);
            // console.log('drag end: start: ' + startAngle + ', end: ' + endAngle);
            const offsetChanged = oldOffset !== split.offset;
            onDragEnd(tier, index, offsetChanged);
        }
        if (onSnapEnd) {
            onSnapEnd();
        }
    };

    @action
    onClick = () => {
        if (this.props.mobileView) return;
        this.selected = true;
        const startAngle = this.rotateAngle + this.startAngle;
        const endAngle = startAngle + this.angelLength;
        if (this.props.onClick) {
            this.props.onClick(this.props.tier, this.props.index, startAngle, endAngle);
        }
    };

    @action
    onDoubleClick = (angle, beat) => {
        if (this.props.mobileView) return;
        this.selectedBeat = beat;
        this.props.split.selectedBeats = [beat];
        if (this.props.onSelected) {
            this.props.onSelected(this.props.tier, this.props.index);
        }
    };

    @action
    onDoubleClickEmpty = (angle, beat) => {
        if (this.props.mobileView) return;
        this.selectedBeat = beat;
        this.props.split.selectedBeats = [beat];
        if (this.props.onSelected) {
            this.props.onSelected(this.props.tier, this.props.index, true);
        }
    };

    @action
    onDragSelectedStart = (angle, beat) => {
        this.duringSelectDrag = true;
        this.selectedBeat = beat;
    };

    @action
    onDragSelected = (angle, beat) => {
        const start = this.selectedBeat;
        const end = beat;
        this.props.split.selectedBeats = range(Math.min(start, end), Math.max(start, end) + 1);
    };

    @action
    onDragSelectedEnd = () => {
        this.duringSelectDrag = false;
        // if (this.props.onSelected) {
        //     this.props.onSelected(this.props.tier, this.props.index, this.props.split.selectedBeats);
        // }
    };

    @action
    onHover = () => {
        if (this.props.mobileView) return;
        this.props.onMouseOver();
        this.isHovering = true;
    };

    @action
    onHoverLeave = () => {
        if (this.props.mobileView) return;
        this.props.onMouseLeave();
        this.isHovering = false;
    };

    handler = (angle, beat) => {
        console.log(`got event: ${beat} angel: ${angle}`);
    };


    render() {
        const {index, split, fillColor, beatCount, absBeatCount, tier, track, wave, globalDuringDrag, downloadPct, mobileView, studioStore} = this.props;
        const {advancedMode} = studioStore;
        const startAngle = this.rotateAngle + this.startAngle;
        const startAngleNoTrim = (isNumber(this.startAngleNoTrim) ? this.startAngleNoTrim : this.startAngle);
        const endAngle = Math.min(startAngle + this.angelLength, tau * 0.9999999);
        let hovering = (this.duringDrag || this.isHovering) && advancedMode;
        let showWave = !mobileView && (globalDuringDrag || this.isHovering || this.selected || this.props.studioStore.isShowWaves);
        if (isIpad()) {
            hovering = hovering || split.selected;
        }

        return (
            <g>
                {index === 0 && <StudioPlayerTrackArc
                    mobileView={mobileView} tier={tier} beatCount={beatCount} startAngle={0} endAngle={tau}
                    className={'studio-grid-arc-bg fill'} onDoubleClick={this.onDoubleClickEmpty}
                    withCorner={true} isHovering={!mobileView && hovering} fillColor={'transparent'}/>}


                <StudioPlayerTrackArc
                    mobileView={mobileView} tier={tier} beatCount={beatCount} startAngle={startAngle} endAngle={startAngle + (endAngle - startAngle) * downloadPct}
                    className={'studio-grid-arc-item fill'} hoverClassName={'studio-grid-arc-hover'}
                    onDrag={this.onDragStem} onDragStart={this.onDragStemStart}
                    onDragEnd={this.onDragStemEnd} onClick={this.onClick}
                    onMouseOver={this.onHover} onMouseLeave={this.onHoverLeave}
                    onDoubleClick={this.onDoubleClick} fillColor={fillColor} withCorner={true}
                    isHovering={!mobileView && (hovering)}
                />

                {!mobileView && <Fragment>
                    <CSSTransition animation={"fade-quick"} component={"g"} timeout={{enter: 500, leave: 500}}>
                        {showWave && wave && <StudioPlayerTrackWave tier={tier} split={split} startAngle={startAngleNoTrim}
                            endAngle={this.endAngle} rotateAngle={this.rotateAngle} trackBeatCount={track.beatCount}
                            absBeatCount={absBeatCount} wave={wave}/>}
                    </CSSTransition>

                    {split.selectedBeats && split.selectedBeats.map((bar) => {
                        const barStartAngle = Math.max((this.duringDrag ? this.rotateAngle - this.prevRotateAngle : 0) + convertToAngles(bar, beatCount), 0);
                        const barEndAngle = Math.min((index === 0 ? tau : this.maxAngle), (this.duringDrag ? this.rotateAngle - this.prevRotateAngle : 0) + convertToAngles(bar + 1, beatCount));
                        return <StudioPlayerTrackArc
                            key={bar} tier={tier} beatCount={beatCount} startAngle={barStartAngle}
                            endAngle={barEndAngle} className={'studio-grid-arc-selected'} onMouseOver={this.onHover}
                            onClick={this.onClick} onDoubleClick={this.onDoubleClick} onMouseLeave={this.onHoverLeave}
                            isHovering={hovering}
                            onDrag={this.onDragSelected} onDragEnd={this.onDragSelectedEnd}
                        />;
                    })}

                    <StudioPlayerTrackHandle
                        tier={tier} angle={startAngle} beatCount={beatCount} isLeft={true}
                        className={'studio-handles'} hoverClassName={'studio-handles-hover'} onDrag={this.onTrimLeft}
                        onDragEnd={this.onTrimEnd} onDoubleClick={this.onDoubleClick} onMouseOver={this.onHover}
                        onMouseLeave={this.onHoverLeave} isHovering={hovering}/>

                    <StudioPlayerTrackHandle
                        tier={tier} angle={endAngle} beatCount={beatCount} isLeft={false} className={'studio-handles'}
                        hoverClassName={'studio-handles-hover'} onDrag={this.onTrimRight} onDragEnd={this.onTrimEnd}
                        onDoubleClick={this.onDoubleClick} onMouseOver={this.onHover} onMouseLeave={this.onHoverLeave}
                        isHovering={hovering}/>
                </Fragment>}
            </g>
        );
    }
}

StudioPlayerTrackLegoArc.propTypes = {
    index: PropTypes.number.isRequired,
    split: PropTypes.object.isRequired,
    tier: PropTypes.number.isRequired,
    beatCount: PropTypes.number.isRequired,
    absBeatCount: PropTypes.number.isRequired,
    fillColor: PropTypes.string,
    minStartAngle: PropTypes.number,
    maxEndAngle: PropTypes.number,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onHover: PropTypes.func,
    onHoverLeave: PropTypes.func,
    onDragStart: PropTypes.func,
    onDragEvent: PropTypes.func,
    onDragEnd: PropTypes.func,
    onTrimStart: PropTypes.func,
    onTrim: PropTypes.func,
    onTrimEnd: PropTypes.func,
    onSnap: PropTypes.func,
    onSnapEnd: PropTypes.func,
    mobileView: PropTypes.bool,
};

export default StudioPlayerTrackLegoArc;
